import styled, { css } from "styled-components";
import {
  OnestNormalSmall,
  OnestSemiBoldDefault,
  OnestSemiBoldMed,
} from "../styled/TextComponents";
import {
  color_green,
  color_green_light,
  color_grey_dark,
  color_grey_light,
  color_grey_ultra_dark,
  color_grey_ultra_light,
  color_red_default,
  color_white,
} from "../../constants/colors";

export const ProgramCard = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.$width};
  min-height: 450px;
  border-radius: 20px;
  padding: 22px 22px 18px;
  background-color: ${color_white};
  box-sizing: border-box;
  gap: 16px;
  overflow: hidden;
`;

export const ProgramHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 455px) {
    flex-direction: column;
  }
`;

export const ProgramHeaderCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ProgramTitle = styled(OnestSemiBoldMed)`
  font-size: 24px;
  line-height: 1.2;
  color: ${color_grey_ultra_dark};
`;

export const ProgramProgressText = styled(OnestNormalSmall)`
  font-size: 13px;
  color: ${color_grey_dark};
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 455px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const AllProgramButton = styled.button`
  flex-shrink: 0;
  height: 32px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid ${color_grey_light};
  background: ${color_white};
  color: ${color_grey_ultra_dark};
  font-family: Onest, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${color_red_default};
    color: ${color_red_default};
  }
`;

export const RemovedLessonsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 11px;
  border-radius: 999px;
  border: 1px solid
    ${(props) => (props.$active ? "rgba(240, 79, 79, 0.35)" : color_grey_light)};
  background: ${(props) => (props.$active ? "rgba(240, 79, 79, 0.08)" : color_white)};
  color: ${(props) => (props.$active ? color_red_default : color_grey_ultra_dark)};
  font-family: Onest, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${color_red_default};
    color: ${color_red_default};
  }
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: ${color_grey_ultra_light};
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${(props) => props.$percent}%;
  border-radius: 999px;
  background: linear-gradient(90deg, ${color_red_default} 0%, #ff8a7a 100%);
  transition: width 0.25s ease;
`;

export const RemovedLessonsPanel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border: 1px solid ${color_grey_light};
  border-radius: 16px;
  background: #fafafa;
`;

export const RemovedLessonsHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 4px;

  @media (max-width: 455px) {
    flex-direction: column;
  }
`;

export const RemovedLessonsTitle = styled(OnestSemiBoldDefault)`
  color: ${color_grey_ultra_dark};
  font-size: 14px;
`;

export const RestoreAllButton = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: ${color_red_default};
  font-family: Onest, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    color: ${color_grey_dark};
    cursor: wait;
  }
`;

export const RemovedLessonItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 11px;
  border-radius: 12px;
  background: ${color_white};
`;

export const RemovedLessonInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

export const RemovedLessonName = styled(OnestSemiBoldDefault)`
  color: ${color_grey_ultra_dark};
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RestoreLessonButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  height: 30px;
  padding: 0 10px;
  border: none;
  border-radius: 999px;
  background: ${color_green_light};
  color: ${color_green};
  font-family: Onest, sans-serif;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.55;
    cursor: wait;
  }
`;

export const LessonList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HiddenLessonsDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  margin-left: 26px;
  padding-bottom: 8px;
`;

export const ExpandLessonsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 4px 2px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${color_grey_dark};
  font-family: Onest, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.15s ease;

  svg {
    flex-shrink: 0;
    font-size: 14px;
  }

  &:hover,
  &:focus-visible {
    color: ${color_red_default};
  }

  &:focus-visible {
    outline: 2px solid rgba(240, 79, 79, 0.25);
    outline-offset: 2px;
  }
`;

export const LessonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 10px;
  cursor: default;
`;

export const Rail = styled.div`
  position: relative;
  width: 16px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
`;

export const RailLine = styled.span`
  position: absolute;
  top: 22px;
  bottom: ${(props) => (props.$last ? "22px" : "-8px")};
  width: 2px;
  background: ${(props) =>
    props.$done ? color_green : props.$current ? color_red_default : color_grey_light};
  opacity: ${(props) => (props.$last ? 0 : 1)};
`;

export const RailDot = styled.span`
  position: relative;
  z-index: 1;
  margin-top: 18px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-sizing: border-box;
  background: ${(props) =>
    props.$done ? color_green : props.$current ? color_red_default : color_white};
  border: 2px solid
    ${(props) =>
      props.$done
        ? color_green
        : props.$current
          ? color_red_default
          : color_grey_light};
  box-shadow: ${(props) =>
    props.$current ? "0 0 0 4px rgba(240, 79, 79, 0.16)" : "none"};
`;

const currentCard = css`
  background: #fff7f7;
  border-color: ${color_red_default};
  box-shadow: 0 8px 20px rgba(240, 79, 79, 0.08);
`;

const selectedCard = css`
  background: #fff7f7;
  border-color: ${color_red_default};
  box-shadow: 0 8px 20px rgba(240, 79, 79, 0.08);
`;

const lockedCard = css`
  opacity: 0.62;
`;

export const LessonCard = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  padding: 10px 44px 10px 10px;
  border-radius: 18px;
  border: 1.5px solid ${color_grey_ultra_light};
  background: ${color_white};
  box-sizing: border-box;
  cursor: ${(props) => (props.$trials ? "pointer" : "inherit")};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;

  ${(props) => props.$current && currentCard}
  ${(props) => props.$selected && selectedCard}
  ${(props) => props.$locked && lockedCard}

  &:hover {
    border-color: ${(props) =>
      props.$current || props.$selected
        ? color_red_default
        : "rgba(240, 79, 79, 0.35)"};
  }

  @media (max-width: 455px) {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 40px 44px 12px;
  }
`;

export const ThumbWrap = styled.div`
  width: 108px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 14px;
  overflow: hidden;
  background: ${color_grey_ultra_light};
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
  }

  ${LessonRow}:hover & img {
    transform: scale(1.06);
  }

  @media (max-width: 455px) {
    width: 100%;
    height: 120px;
  }
`;

export const LessonBody = styled.div`
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LessonTitle = styled(OnestSemiBoldDefault)`
  font-size: 15px;
  line-height: 1.3;
  color: ${color_grey_ultra_dark};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const LessonMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

export const MetaChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: ${color_grey_ultra_light};
  color: ${color_grey_ultra_dark};
  font-family: Onest, sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
`;

export const NowBadge = styled(MetaChip)`
  background: ${color_red_default};
  color: ${color_white};
`;

export const StatusButton = styled.button`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${(props) => (props.$done ? color_green_light : color_grey_ultra_light)};
  color: ${(props) => (props.$done ? color_green : color_grey_dark)};

  &:disabled {
    opacity: 0.42;
    cursor: not-allowed;
  }

  @media (max-width: 455px) {
    position: absolute;
    right: 12px;
    bottom: 12px;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${color_grey_dark};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: ${color_grey_ultra_light};
    color: ${color_red_default};
  }
`;

export const EmptyProgram = styled(OnestNormalSmall)`
  color: ${color_grey_dark};
  padding: 24px 4px 8px;
`;

export const TrialActionPanel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 15px;
  border-radius: 16px;
  background: linear-gradient(135deg, #fff7f7 0%, #ffffff 100%);
  border: 1px solid rgba(240, 79, 79, 0.18);
`;

export const TrialActionCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-family: Onest, sans-serif;

  strong {
    color: ${color_grey_ultra_dark};
    font-size: 14px;
    font-weight: 600;
  }

  span {
    color: ${color_grey_dark};
    font-size: 12px;
    line-height: 1.4;
  }
`;

export const TrialLevelButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TrialLevelButton = styled.button`
  min-height: 30px;
  padding: 5px 10px;
  border: 1px solid
    ${(props) => (props.$recommended ? color_green : color_grey_light)};
  border-radius: 999px;
  background: ${(props) => (props.$recommended ? color_green_light : color_white)};
  color: ${(props) => (props.$recommended ? color_green : color_grey_ultra_dark)};
  font-family: Onest, sans-serif;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${color_red_default};
    color: ${color_red_default};
  }

  &:disabled {
    opacity: 0.55;
    cursor: wait;
  }
`;

export const UndoBar = styled.div`
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 1000;
  transform: translateX(-50%);
  width: min(440px, calc(100vw - 32px));
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 14px 12px 16px;
  border-radius: 16px;
  box-sizing: border-box;
  background: #363636;
  color: ${color_white};
  box-shadow: 0 14px 38px rgba(43, 43, 43, 0.24);
`;

export const UndoCopy = styled.div`
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-family: Onest, sans-serif;

  strong {
    font-size: 13px;
    font-weight: 600;
  }

  span {
    overflow: hidden;
    color: rgba(255, 255, 255, 0.68);
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const UndoButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 34px;
  padding: 0 12px;
  border: none;
  border-radius: 999px;
  background: ${color_white};
  color: ${color_red_default};
  font-family: Onest, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
`;
